module.exports = __webpack_public_path__ + "static/media/vtex16.d21e4380.png";